import { Box, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'

const Footer = () => {
    const [navigateLink,setNavigateLink]=useState("")
    return (
            <Box
                className="fixed-footer d-flex"
                component="footer"
                sx={{

                    backgroundColor: 'background.paper',
                    borderTop: '1px solid #e0e0e0',

                }}
                // container
                gap={2}
                alignItems="center"
                justifyContent="center"
                textAlign="center"
            >
                <Box item xs={12}  >
                    <Typography color="textSecondary">
                        <small   className='mt-1'> Rayiq Live © {new Date().getFullYear()} All rights reserved.</small>
                    </Typography>
                </Box>
                <Box item xs={4} >
                    <a href={navigateLink} target="_blank" rel="noopener noreferrer" >
                        <Typography color='primary' style={{ textDecoration: 'underline' }} > <small className='mr-3' onClick={()=>{setNavigateLink("/privacy-policy")}}>Privacy Policy</small> 
                         <small  onClick={()=>{setNavigateLink("/terms-conditions")}}>T&C</small> </Typography>
                    </a>
                </Box>
            </Box>
        // </Box>
    )
}

export default Footer